<template>
  <section class="splash">
    <div class="splash__content">
      <div class="splash__content__top">
        <img :src="logoFromExt" alt="Football PRO Game">
      </div>
      <div class="splash__content__middle">
        <h2 v-if="getTranslations.home_splash_please_wait">
          {{ getTranslations.home_splash_please_wait }}
        </h2>
        <h2>
          {{ getTranslations.home_splash_play }} <br>{{ getTranslations.home_splash_football }}
         </h2>
        <img src="static/images/Panini_Logo.png" alt="Panini Logo" width="">
      </div>
    </div>
    <div class="splash__footer">
      <div class="splash__footer__content">
        <p>{{ getTranslations.home_splash_distributed }} </p>
        <img :src="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_footer_operator_logo')">
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'splash-screen',
  data() {
    return {
      logoFromExt: '/ext/logos/football_pro_logo.png',
    };
  },
  created() {
    this.fetchdata();
  },
  methods: {
    fetchdata() {
      /* eslint-disable */
      setTimeout(() => {
        this.$router.push(`${sessionStorage.getItem('toPage')}`);
        sessionStorage.setItem('splashScreenProgrammaticallyRefresh', 'true');
        sessionStorage.setItem('splashScreenAlreadyDisplayed', 'true');
        window.location.reload();
      }, this.splashTimer);
    },
  },
  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
      'splashTimer',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/SplashScreen.vue